module.exports = __webpack_public_path__ + "img/info_icon.d925969.png";